import Header from '../Header'
import CartListView from '../CartListView'
import EmptyCartView from '../EmptyCartView'
import CartContext from '../../context/CartContext'

import './index.css'

const Cart = () => (
  <CartContext.Consumer>
    {value => {
      const {cartList, removeItemFromCart} = value
      const isShowList = cartList.length === 0
      const onTapToRemoveAllButton = () => {
        removeItemFromCart()
      }

      return (
        <>
          <Header />
          {isShowList ? (
            <EmptyCartView />
          ) : (
            <div className="cart-container">
              <div className="cart-content-container">
                <div className="cart-top-card">
                  <h1 className="cart-heading">My Cart</h1>
                  <button
                    type="button"
                    className="button removeButton"
                    onClick={onTapToRemoveAllButton}
                  >
                    Remove All
                  </button>
                </div>
                <CartListView />
              </div>
            </div>
          )}
        </>
      )
    }}
  </CartContext.Consumer>
)
export default Cart
